export enum ActionsTableHeaderEnum {
    AMOUNT = 'amount',
    BRAND = 'brand',
    DATE = 'date',
    STATUS = 'status',
}
